import { CachePolicy } from 'contentstack';
import { unstable_cache } from 'next/cache';

import {
    ContentStack,
    ContentStackLivePreview,
} from '@nxt-costco-com/forge-digital-components';
import type {
    ContentTypeProps,
    LocaleProps,
} from '@nxt-costco-com/forge-digital-components';

const _findAll = async function _findAll<T>(
    contentType: ContentTypeProps,
    enableLivePreview: boolean,
    lang: LocaleProps,
    limit?: number,
): Promise<T> {
    let stackClient = ContentStack;

    if (enableLivePreview) {
        stackClient = ContentStackLivePreview;
        stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
    }

    try {
        const query = stackClient.stack
            .ContentType(contentType)
            .Query()
            .language(lang)
            .toJSON();

        const result = await query.find();

        if (limit === 1) {
            return result?.[0]?.[0] as T;
        } else {
            return result as T;
        }
    } catch (err) {
        throw new Error(
            `An error occurred in _findAll: ${JSON.stringify(err)}`,
        );
    }
};

const cached_findAll = unstable_cache(_findAll, ['search_findAll'], {
    revalidate: 1800,
});

export const findAll = async function findAll<T>(
    contentType: ContentTypeProps,
    enableLivePreview: boolean,
    lang: LocaleProps,
    limit?: number,
): Promise<T> {
    const fn = typeof window === 'undefined' ? cached_findAll : _findAll;

    return fn(contentType, enableLivePreview, lang, limit);
};
